import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./bop010w010.css";
import BOP010W010Template from "./bop010w010.template";
import useApiRequest from "../../common/useApiRequest";

const BOP010W010 = () => {
  const [id, setId] = useState("");
  const [password, setPassword] = useState("");

  const navigate = useNavigate();
  const { isLoading, execute } = useApiRequest();

  const handleLogin = async () => {
    const result = await execute(
      `${process.env.REACT_APP_API_BASE_URL}/api/auth/login`,
      {
        method: "POST",
        body: JSON.stringify({ id, password }),
      },
    );

    if (!result.ok) {
      alert(result.error.message);
      return;
    }

    navigate("/bop020w010");
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    handleLogin();
  };

  return (
    <BOP010W010Template
      id={id}
      password={password}
      isLoading={isLoading}
      onIdChange={setId}
      onPasswordChange={setPassword}
      onSubmit={handleSubmit}
    />
  );
};

export default BOP010W010;
